module.exports = __webpack_public_path__ + "static/media/logo.e6144672.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 37
// module chunks = 0